class WireGuideDatabase extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.groupedData = null;
    this.featuredData = [];
    this.cache = new Map();
  }

  static get observedAttributes() {
    return ["data"];
  }

  connectedCallback() {
    if (!this.shadowRoot.innerHTML) {
      this.shadowRoot.innerHTML = `
      <link rel="stylesheet" href="/cdn/shop/t/22/assets/webcomponent.css">
    `;
    }
  }

  async fetchData(url) {
    if (this.cache.has(url)) {
      return this.cache.get(url).cloneNode(true);
    }

    const response = await fetch(url);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const result = doc.querySelector(".test");

    if (result) {
      this.cache.set(url, result.cloneNode(true));
    }

    return result;
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    if (name === "data") {
      this.groupedData = JSON.parse(newValue);
      console.log(this.groupedData);
      this.render();
      this.handleBrandClick({
        name: this.groupedData[0].links[0].name,
        pdf: this.groupedData[0].links[0].pdf,
        image: this.groupedData[0].links[0].image,
        description: this.groupedData[0].links[0].description,
      });
      //   this.groupedData = this.groupData(this.data);
    }
  }

  render() {
    if (!this.groupedData || !Array.isArray(this.groupedData)) return;

    const className = `card-container ${
      this.background === "#ffffff" ? "white" : ""
    }`;
    // Tabs: Featured first, then grouped items by letter
    const tabsHTML = `
              <div class="custom-container">
                  <div class="brand-list ${className}">
                  ${this.groupedData
                    .map(
                      (group, index) => `
                        <a data-tab-index="${index}" aria-selected="${
                        index === 0
                      }" class="brand-tab tab ${index === 0 ? "active" : ""}">
                          <div style="width: 50px" class="item">
                            <img src="${group.image}" class="center">
                          </div>
                        </a>
                    `
                    )
                    .join("")}
                  
                  </div>

                   <div class="manuals ${className}">
                      ${this.groupedData
                        .map(
                          (group, index) => `
                            <div 
                              data-tab-index="${index}" 
                              class="manual-container ${
                                index !== 0 ? "hidden" : ""
                              }"
                            >
                              ${group.links
                                .map(
                                  (link) => `
                                    <div class="manual-item">
                                        <a href="#" data-name="${
                                          link.name
                                        }" data-image='${
                                    link.image
                                  }' data-pdf="${link.pdf}" data-description="${
                                    link.description
                                  }">
                                            ${link.name.trim()}
                                        </a>
                                   </div>
                                  `
                                )
                                .join("")}
                            </div>
                          `
                        )
                        .join("")}
                    </div>
          
                     <div class="wire-guide-container ${className}">
                         ${
                           this.groupedData.length
                             ? this.groupedData
                                 .map(
                                   (group, index) => `
                                    <div data-tab-index="${index}" style="width: 100%;" class="group ${
                                     index !== 0 ? "hidden" : ""
                                   }">
                            
                                    </div>
                                  `
                                 )
                                 .join("")
                             : `<div class="skeleton-content"></div>`
                         }
                    </div>
              </div>
          `;

    this.shadowRoot.innerHTML = `
          <link rel="stylesheet" href="/cdn/shop/t/22/assets/webcomponent.css?v=${Date.now()}">
          <link rel="stylesheet" href="/cdn/shop/t/22/assets/tailwind.min.css?v=${Date.now()}">
          <style>
           
          </style>
          ${tabsHTML}
        `;

    this.shadowRoot.querySelectorAll(".tab").forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick.bind(this));
    });

    this.shadowRoot
      .querySelectorAll(".manual-container .manual-item")
      .forEach((group) => {
        group.addEventListener("click", this.handleBrandClick.bind(this));
      });
  }

  handleBrandClick = async (eventOrData) => {
    let name, pdf, image, description, tabIndex, container;
    const placeholderText =
      "Use these images to help you wire up your garage or gate device step by step. A wire guide is designed to keep your cables neatly aligned, reducing the risk of tangles or snags during installation. Simply thread the cable through the guide as shown, position it correctly near the drum or pulley, and make sure it's secure. This ensures the wire runs smoothly during operation, improves safety, and helps extend the life of your system. Whether you're installing a new setup or replacing an old one, the wire guide makes the process easier and more reliable.";

    if (eventOrData?.currentTarget) {
      // Triggered from a click
      eventOrData.preventDefault();
      const el = eventOrData.currentTarget.children[0];
      name = el.dataset.name;
      pdf = el.dataset.pdf;
      image = el.dataset.image;
      description = el.dataset.description
        ? el.dataset.description
        : placeholderText;
      tabIndex = eventOrData.currentTarget.parentElement.dataset.tabIndex;
      container = this.shadowRoot.querySelector(
        `.group[data-tab-index="${tabIndex}"]`
      );
    } else {
      // Triggered programmatically
      const group = this.groupedData[0];
      const link = group.links[0];
      name = link.name;
      pdf = link.pdf;
      image = link.image;
      description = link.description;
      tabIndex = 0;
      container = this.shadowRoot.querySelector(`.group[data-tab-index="0"]`);
    }

    if (!container) return;

    container.innerHTML = `
    <div class="guide">
      <div>
        <h3 class="tw-mb-2 tw-text-[21px] heading">${name}</h3>
        <div class="image-container">
        <img src="${image}" width="500" />
        </div>
      </div>
      <div class="description-container">
        <h3 class="tw-mb-2 tw-text-[21px] heading">Instruction</h3>
        <div class="description">
        ${description}
        </div>
        <div class="button-container">
        <a class="tw-w-fit wire-pdf button" href="${pdf}" target="_blank">Download Manual</a>
        </div>
      </div>
    </div>
  `;
  };

  handleTabClick = async (event) => {
    const index = event.currentTarget.dataset.tabIndex;

    this.shadowRoot.querySelectorAll(".tab").forEach((tab) => {
      tab.setAttribute("aria-selected", tab.dataset.tabIndex === index);
      tab.classList.toggle("active", tab.dataset.tabIndex === index);
    });

    this.shadowRoot.querySelectorAll(".group").forEach((group) => {
      group.classList.toggle("hidden", group.dataset.tabIndex !== index);
    });

    this.shadowRoot.querySelectorAll(".manual-container").forEach((group) => {
      group.classList.toggle("hidden", group.dataset.tabIndex !== index);
    });
  };
}

customElements.define("wire-guide-database", WireGuideDatabase);